module.exports = __webpack_public_path__ + "static/_colorbase_BL001-e2424cce432ffce0ffd0a8f3a35a17fe.jpg";